import axios from "axios"
import RestApiService from "./RestApiService"

const controller = "/productoVendor"

const ProductoService = {
    cargarOpciones: async () => {
        const { data } = await axios.post(`${controller}/cargarOpciones`)
        return data
    },
    buscarCategorias: async (request) => {
        const { data } = await axios.post(`${controller}/buscarCategorias`, request)
        return data
    },
    getTiposProductoxCategoria: async (request) => {
        const { data } = await axios.post(`${controller}/getTiposProductoxCategoria`, request)
        return data
    },
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    registrar: async (request) => {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    obtener: async (request) => {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    modificar: async (request) => {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
    deshabilitar: async (request) => {
        const { data } = await axios.post(`${controller}/deshabilitar`, request)
        return data
    },
    buscarRapido: async (request) => {
        // const { data } = await axios.post(`${controller}/buscarRapido`, request)
        // return data
        return RestApiService.send(`${controller}/buscarRapido`, request)
    },
    buscarIndice: async (request) => {
        const { data } = await axios.post(`${controller}/buscarIndice`, request)
        return data
    },
}

export default ProductoService